import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";

// index.html has a fallback title/description for crawlers that don't run JavaScript.
// Remove them here so each page's own title/description (set with Helmet) is the only one.
document.querySelectorAll("[data-static-seo]").forEach(el => el.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <HelmetProvider>
        <App />
    </HelmetProvider>
);